import { render, staticRenderFns } from "./ApprovalCheck.vue?vue&type=template&id=16894fa3&scoped=true"
import script from "./ApprovalCheck.vue?vue&type=script&lang=js"
export * from "./ApprovalCheck.vue?vue&type=script&lang=js"
import style0 from "./ApprovalCheck.vue?vue&type=style&index=0&id=16894fa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16894fa3",
  null
  
)

export default component.exports